export function validateEmail(email: string) {
    const mailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return mailRegExp.test(email);
}
